import React from "react";
import { useTranslation } from "react-i18next";

import { filterRelevantPickupFields } from "./utils";
import { LocationData } from "../../../../../models/LocationData";

import "./styles.scss";

interface IPickupFieldsProps {
  locationData: LocationData;
}

export const PickupFields: React.FC<IPickupFieldsProps> = (props) => {
  const { locationData } = props;
  const pickupFields = locationData.pickup_fields;

  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.pickupFields.${key}`);

  const relevantPickupFields = filterRelevantPickupFields(locationData);

  return (
    <div className="project-facility-details-pickup-fields">
      <h2 className="project-facility-details-pickup-fields-title">
        {t("section_title")}
      </h2>
      <div className="field-items">
        {pickupFields &&
          Object.keys(relevantPickupFields).map((key) => (
            <div className="field-item" key={key}>
              <i
                className={`icons ${
                  relevantPickupFields[key] ? "icon-done" : "icon-error"
                }`}
              ></i>
              <span className="field-name">{t(key)}</span>
            </div>
          ))}
      </div>
    </div>
  );
};
